var THF = THF || {};
THF.Interface = THF.Interface || {};

(function ($, jQuery) {
    'use strict';

    THF.Interface.HealthHubArticlePageTracking = function (options) {
        console.log('article page loaded');
        var defaults = {

            selectors: {
                parentElem: '.health-hub-article',
                relatedArticles: '.related-articles',
                articleTiles: '.article-tile-featured',
                serviceTiles: '.hh-service-tile'
            }
        };

        options = $.extend(true, {}, defaults, options);


        /**********************************
         // Declare DOM elements
         **********************************/
        var parentElem = $(options.selectors.parentElem);
        var relatedArticles = $parentElem(options.selectors.relatedArticles);
        var articleTiles = relatedArticles.find(options.selectors.articleTiles);
        var serviceTiles = relatedArticles.find(options.selectors.serviceTiles);


        /**********************************
         // Helper function to return a jQuery object, which is a child of 'parentElem'
         **********************************/
        function $parentElem(selector) {
            return $(options.selectors.parentElem + ' ' + selector);
        }


        /**********************************
         // Event binding
         **********************************/
        function bindEvents() {

            /* Article Page >> Related Articles >> Article Tiles */
            if (articleTiles.length > 0) {
                articleTiles.each(function () {
                    var articleTileButton = $(this).find('a');
                    articleTileButton.click(function (e) {
                        //e.preventDefault();
                        //console.log('Article Page >> Related Articles >> Article Tile clicked.');
                        //console.log($(this).attr('href'));
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({
                            'event': 'articleRelatedArticleCard',
                            'type': 'Article',
                            'pagePath': $(this).attr('href')
                        });
                    });
                });
            }


            /* Article Page >> Related Articles >> Service Tiles */
            if (serviceTiles.length > 0) {
                serviceTiles.each(function () {
                    var serviceTileButton = $(this).find('a');
                    serviceTileButton.click(function (e) {
                        //e.preventDefault();
                        //console.log('Article Page >> Related Articles >> Service Tile clicked.');
                        //console.log($(this).attr('href'));
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({
                            'event': 'articleRelatedArticleCard',
                            'type': 'Service',
                            'pagePath': $(this).attr('href')
                        });
                    });
                });
            }
        }

        /**********************************
         // Simple constructor
         **********************************/
        function __construct() {

            // Init
            if (parentElem.length > 0) {
                bindEvents();
            }
        }

        __construct();


        //
        // Make some events accessible from global scope
        //
        return {

        };
    };
})(jQuery, jQuery)